export default __webpack_public_path__ + "static/media/ItemMasterFormat.71fbfbb6.csv";